<template>
  <Container>
    <div v-if="dataCargada && !errorCarga" class="px-3">
      <div class="row px-lg-0 mb-3 mx-0" />
      <Encabezado :nombre="establecimiento.nombre"></Encabezado>
      <Iconografia />
      <b-row>
        <!--COLUMNA IZQUIERDA-->
        <b-col cols="12" lg="7" class="col-print-7 mb-3">
          <InformacionInstitucional :establecimiento="establecimiento" />
        </b-col>
        <!--COLUMNA DERECHA-->
        <b-col cols="12" lg="5" class="col-print-5">
          <UbicacionContactosVacantes :establecimiento="establecimiento" />
        </b-col>
        <b-col cols="12">
          <div
            class="bg-light px-4 py-3 text-morado-claro text-left mt-5 mx-3 mx-lg-0 d-flex"
          >
            <FontAwesomeIcon icon="info" class="mr-3" />
            <span class="border-left pl-3"
              >El contenido de esta ficha fue entregado por el establecimiento a
              través del Sistema de Información General de Estudiantes y la
              Agencia de Calidad de la Educación.</span
            >
            <!--La información institucional, ubicación, vacantes, jornadas y programas es responsabilidad del establecimiento-->
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="text-center px-3" v-else-if="errorCarga">
      <FontAwesomeIcon
        icon="exclamation-triangle"
        class="fa-2x mb-2 mt-2"
        style="color: red;"
      ></FontAwesomeIcon>
      <h3>
        El RBD del establecimiento no existe o ha ocurrido un error en la carga
      </h3>
    </div>
    <Flecha />
  </Container>
</template>

<script>
import ApiEstablecimientos from "@/services/ApiEstablecimientos";
import Container from "@/components/wrapper/Container";
import InformacionInstitucional from "@/components/ficha/InformacionInstitucional";
import UbicacionContactosVacantes from "@/components/ficha/UbicacionContactosVacantes";
import Encabezado from "@/components/ficha/Encabezado";
import Iconografia from "@/components/generales/Iconografia";
import Flecha from "@/components/generales/Flecha";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faInfo);
export default {
  //props
  components: {
    FontAwesomeIcon,
    InformacionInstitucional,
    Container,
    Encabezado,
    Iconografia,
    UbicacionContactosVacantes,
    Flecha
  },
  //data
  data() {
    return {
      dataCargada: false,
      errorCarga: false,
      establecimiento: {}
    };
  },
  //cycle hooks
  async created() {
    await this.getFicha();
    this.dataCargada = true;
    this.establecimiento ? "" : (this.errorCarga = true);
  },
  //computed props
  //methods
  methods: {
    //obtiene datos de la ficha de establecimientos segun rbd
    getFicha: async function() {
      this.$emit("cargar");
      let data = await ApiEstablecimientos.getFichaEstablecimiento(
        this.$route.params.rbd,
        this
      );

      this.establecimiento = data;
      this.$emit("cargado");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/FichaEstablecimiento.vue